import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`If you are using the EU cloud then use `}<inlineCode parentName="p">{`eu`}</inlineCode>{` instead of `}<inlineCode parentName="p">{`us`}</inlineCode>{` in all domains (e.g. `}<inlineCode parentName="p">{`us.i.posthog.com`}</inlineCode>{` -> `}<inlineCode parentName="p">{`eu.i.posthog.com`}</inlineCode>{`).`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      